/**
 * Created by markusr on 26.2.2016.
 * Slide show component for gimlet player
 * Cube effect not supported in IE -> uses flipcard
 * Ring effect not supported in IE and old Safari -> uses 2D
 * Coverflow has issues in FireFox
 * Width < 500 then Ring -> 2D
 * @component {"type":"SlideShow","version":"1.3"}
 */

 define('component-slide-show',['jquery', 'knockout', 'helpers', 'training', 'user-answers', 'qTip'], function($, ko, helpers, Training, UserAnswers) {

    return function(parentVM, dataContext) {
        var self = this,
            trainingVM = parentVM.training,
            entityVM = parentVM.entity,
            layoutVM = parentVM.layout,
            showNextInstruction = true,
            isMSEdge = !!window.navigator.userAgent.match(/ Edge/i),
            isFirefox = !!window.navigator.userAgent.match(/firefox/i),
            training = new Training(),
            userAnswers = new UserAnswers();

        self.autoplay       = ko.observable();
        self.classes        = ko.observable();
        self.form           = ko.observable();
        self.orientation    = ko.observable();
        self.loop           = ko.observable();
        self.ownNavi        = ko.observable();
        self.imageSrcs      = ko.observable();
        self.renderType     = ko.observable();
        self.nextTooltip    = ko.observable();
        self.nextTooltipText = ko.observable();

        function preventNextTooltip(){
            showNextInstruction = false;
        }

        self.items = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                content = helpers.component.getContent(entity.componentsJSON, 'SlideShow'),
                arr = helpers.component.parseProp(content, 'items', 'Slide');

            if (!arr.length) {
                return arr;
            }

            self.autoplay((content.autoplay) ? parseInt(content.autoplay)*1000: null);
            self.form(content.form);
            self.orientation(content.orientation);
            self.ownNavi(content.ownNavi !== false);
            self.loop(content.loop && self.ownNavi());
            self.renderType(content.renderType);
            self.nextTooltip(content.nextTooltip);
            self.nextTooltipText(content.nextTooltipText || dataContext.learning.lang.slideshowNextTooltip || undefined);

            // IE and old Safari + cube fix
            if (!Modernizr.preserve3d && self.renderType() === 'cube') {
                self.renderType('flipcard')
            }

            // IE and old Safari + ring fix
            if (!Modernizr.preserve3d && self.renderType() === 'ring') {
                self.renderType('2d');
            }

            // FF + coverflow fix
            if(isFirefox && isMSEdge && self.renderType() === 'coverflow'){
                self.renderType('2d')
            }

            if (((window.innerWidth || document.body.clientWidth) < 500) && self.renderType() === 'ring') {
                self.renderType('2d')
            }

            var preClasses = (self.renderType() === '2d' || self.renderType() === 'default') ? 'two-d' : self.renderType(),
                interacted = (userAnswers.isPageVisited(ID)) ? true : !content.interaction;

            self.classes(preClasses + ' ' + content.form); // +" "+ slideShowComponent.content.orientation );

            for (var i = 0; i < arr.length; i++) {
                arr[i].src = (arr[i].file) ? 'url(' + trainingVM.parseMediaURL(arr[i].file) + ')' : 'none';
                arr[i].interacted = interacted.toString();
            }

            if (dataContext.debugMode) {
                console.log('slide show');
                console.dir(arr);
            }

            return arr;
        });

        ko.bindingHandlers.pageComponentSlideShow = {
            update: function (element, valueAccessor) {

                ko.unwrap(valueAccessor());

                var settings = {
                        direction: 'horizontal',
                        pagination: '.swiper-pagination',
                        nextButton: '.swiper-button-next',
                        prevButton: '.swiper-button-prev',
                        shortSwipes: false,
                        longSwipes: false,
                        speed: 500,
                        loop: self.loop(),
                        autoplay: self.autoplay(),
                        allowSwipeToPrev: true,
                        allowSwipeToNext: true,
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        paginationClickable: true
                    },
                    update3D = function(){},
                    sliderTransform = function(){};

                var transitionStart = function(){
                    $(settings.nextButton).addClass('swiper-button-disabled');
                    $(settings.prevButton).addClass('swiper-button-disabled');
                };
                switch (self.renderType()) {
                    case 'slideshow':
                        settings.effect = 'fade';
                        settings.slidesPerView = 1;
                        break;

                    case 'ring':
                        var content = helpers.component.getContent(entityVM.componentsJSON(), 'SlideShow'),
                            slideCount = self.items().length,
                            scaleActive = (content.scaleActive != "false"),
                            activeScaler = (self.form() == "wide") ? Math.max(1.2, Math.pow(slideCount, 0.70) / 3): 1.2,
                            inactiveOffsetAdder = (activeScaler-1)/2.4,
                            wrapperRotationX = 0,
                            wrapperRotationY = 0,
                            wrapperY = '0',
                            slideMarginValue = parseInt(content.slideMargin) || ((scaleActive) ? 100: 50),
                            slideMargin = 50,
                            stepDeg = 360 / slideCount,
                            wrapper,
                            circumference,
                            distanceSlides,
                            distanceWrapper,
                            wrapperTransform;

                        sliderTransform = function(realIndex, k, k2){
                            var index = (k2 === 0) ? (realIndex - k) : (realIndex + k),
                                slideAngleAdder;

                            if(k2 === 0){
                                slideAngleAdder = -inactiveOffsetAdder + (k/slideCount*(2*inactiveOffsetAdder));
                            }else{
                                slideAngleAdder =  inactiveOffsetAdder - (k/slideCount*(2*inactiveOffsetAdder));
                            }

                            var angleMultiplier = index + slideAngleAdder,
                                additionalTransform,
                                angle = -0.01 + stepDeg * ((k === 0 || !scaleActive) ? index: angleMultiplier);

                            if(k == 0 && scaleActive){
                                var translateY = -(Math.pow(activeScaler, 0.73) - 1) * 35; // Move active slide up
                                additionalTransform = " scale("+ activeScaler +") translateY("+ translateY +"%) rotateX("+ wrapperRotationX.replace("-", "") +")"
                            }else{
                                additionalTransform = " scale(1) translateY(0) rotateX(0)";
                            }

                            var transString = 'rotateY(' + angle + 'deg) translateZ(' + distanceSlides + 'px)' + additionalTransform;
                            return transString;
                        };
                        update3D = function(swiper){
                            switch (self.renderType()) {
                                case 'ring':
                                    wrapper = swiper.wrapper[0];
                                    slideMargin = (scaleActive) ? (wrapper.clientWidth / slideCount) * slideMarginValue * 0.03 * activeScaler: slideMarginValue;
                                    circumference = (wrapper.clientWidth + slideMargin) * slideCount; //container.clientWidth * slideCount,
                                    distanceSlides = (circumference / (2 * Math.PI));
                                    distanceWrapper = (distanceSlides + slideMargin) * 2.6;
                                    wrapperRotationX = (wrapper.clientWidth < 650) ?
                                        ((content.tilt || -10) * 0.7) + 'deg' :
                                        (content.tilt || -10) + 'deg';
                                    wrapperTransform = "translateZ(-" + distanceWrapper + "px) translateY(" + wrapperY + "px) rotateX(" + wrapperRotationX + ")  rotateY(" + wrapperRotationY + ")";

                                    wrapper.style.transition = "transform 1s";
                                    wrapper.style.transform = wrapperTransform;

                                    var slides = document.querySelectorAll('.swiper-slide-duplicate');
                                    for (var j0 = 0; j0 < slides.length; j0++) {
                                        var slide0 = slides[j0];
                                        slide0.style.transition = 'opacity 0s';
                                        slide0.style.opacity = 0;
                                    }

                                    slides = document.querySelectorAll('.slideshow-comp .js-swiper-slide:not(.swiper-slide-duplicate)');
                                    if (!slides[0].style.transform) {
                                        for (var j = 0; j < slides.length; j++) {
                                            var slide = slides[j];
                                            slide.style.opacity = 0;
                                            slide.style.transition = 'transform 0s';
                                            var position = (j > slides.length / 2) ? j + 1 : j - 1;
                                            slide.style.transform = sliderTransform(0, position, 1); //'rotateY(' + (stepDeg * Math.max(position, 0)) + 'deg) translateZ(' + distanceSlides + 'px)';
                                        }
                                    }
                                    setTimeout(function () {
                                        var delay = 0.2;
                                        for (var j2 = 0; j2 < slides.length; j2++) {
                                            var slide2 = slides[j2];
                                            var tOffset = (j2 > slides.length / 2) ? (slides.length - j2) * delay : j2 * delay;
                                            slide2.style.transition = 'transform ' + (1) + 's, opacity 1s';
                                            slide2.style.opacity = 1;
                                            slide2.style.transitionDelay = tOffset + "s";
                                            slide2.style.transform = sliderTransform(0, j2, 1); //'rotateY(' + (stepDeg * j2) + 'deg) translateZ(' + distanceSlides + 'px)';
                                        }
                                    }, 10);

                                    break;
                            }
                        };

                        settings.effect = 'slide';
                        settings.virtualTranslate = true;
                        settings.updateOnImagesReady = true;

                        // Responsive breakpoints
                        settings.breakpoints = {
                            // when window width is <= 980px
                            980: {
                                effect: 'slide',
                                spaceBetweenSlides: 30
                            }
                        };

                        transitionStart = function(swiper){
                            //console.log(" - - - - - - - - - transitionStart");

                            $(settings.nextButton).addClass('swiper-button-disabled');
                            $(settings.prevButton).addClass('swiper-button-disabled');

                            if(wrapper) {
                                var activeIndex = swiper.activeIndex || 0,
                                    wrapperRotationYOld = wrapperRotationY,
                                    oldNumber = (-wrapperRotationYOld / stepDeg) + 1,
                                    oldNumberFlat = oldNumber % slideCount,
                                    newNumberFlat = (activeIndex + 1) % slideCount;

                                if (oldNumberFlat === newNumberFlat) {
                                    wrapperRotationY = wrapperRotationYOld;

                                } else {
                                    // This fairly complex system tries to keep slides rotating to same direction when
                                    // looping even when loop ends and starts from beginning
                                    var newNumberA = oldNumber + (newNumberFlat - oldNumberFlat);
                                    var newNumberB = newNumberA - slideCount;
                                    var newNumberC = newNumberA + slideCount;

                                    var diffA = newNumberA - oldNumber;
                                    var diffB = newNumberB - oldNumber;
                                    var diffC = newNumberC - oldNumber;
                                    var newIndex = ((Math.abs(diffA) < Math.abs(diffB)) ?
                                                (Math.abs(diffA) < Math.abs(diffC)) ? newNumberA : newNumberC :
                                                (Math.abs(diffB) < Math.abs(diffC)) ? newNumberB : newNumberC
                                        ) - 1;

                                    wrapperRotationY = stepDeg * (-newIndex);
                                }

                                wrapper.style.transitionDuration = (settings.speed/1000)+"s";       // For MS Edge, not animating without 5.1.2017
                                wrapper.style.transform = "translateZ(-" + distanceWrapper + "px) translateY(" + wrapperY + "px) rotateX(" + wrapperRotationX + ") rotateY(" + wrapperRotationY + "deg) ";

                                if ((window.innerWidth || document.body.clientWidth) >= 100) {        // desktop
                                    var realIndex = parseInt(swiper.realIndex);

                                    slides = document.querySelectorAll('.slideshow-comp .js-swiper-slide:not(.swiper-slide-duplicate)');

                                    for (var k = 0; k < slideCount; k++) {
                                        var queries = self.loop() ?
                                            ['.slideshow-comp [data-swiper-slide-index="' + (realIndex - k) + '"]', '.slideshow-comp [data-swiper-slide-index="' + (realIndex + k) + '"]']:
                                            ['.slideshow-comp .swiper-slide:nth-of-type('+ (realIndex - k+1) +')', '.slideshow-comp .swiper-slide:nth-of-type('+ (realIndex + k+1) +')'];

                                        for (var k2 = 0; k2 < queries.length; k2++) {
                                            var slides = document.querySelectorAll(queries[k2]),
                                                backIndex = Math.floor(slideCount / 2),
                                                positionEffectWeight = 1 - Math.abs(backIndex - k) / backIndex;

                                            // Filters make MS Edge render with issues (fragment lines)
                                            var filter = (isMSEdge) ? '':
                                                    'grayscale(' + positionEffectWeight / 3 * 100 + '%) brightness(' + ((1 - positionEffectWeight / 4) * 100) + '%)',
                                                depthClassNumber = Math.round(positionEffectWeight*3),
                                                depthClass = (isMSEdge) ? 'ring-depth-'+ depthClassNumber: '',
                                                transform = sliderTransform(realIndex, k, k2);

                                            for (var l = 0; l < slides.length; l++) {
                                                slides[l].className = slides[l].className.replace(/(?:^|\s)ring-depth-([0-3]?)(?!\S)/g, '') +' '+ depthClass;
                                                slides[l].style.webkitFilter = filter;
                                                slides[l].style.filter = filter;

                                                slides[l].style.transitionDuration = "0.5s";
                                                slides[l].style.transitionDelay = (k === 0 || !scaleActive) ? "0s": "0s";
                                                slides[l].style.transform = transform;
                                            }
                                            // TODO: shadow, reflection,...?
                                        }
                                    }
                                }
                            }

                            setTimeout(swiper.onTransitionEnd, settings.speed);     // Fallback for Edge because somehow CSS transitionend end event doesn't trigger !!!
                        };


                        settings.onInit = function(swiper){
                            setTimeout(function(){
                                // Timeout is needed for ring type, otherwise get container width 1px
                                swiper.activeIndex = 0;

                                update3D(swiper);

                                transitionStart(swiper);

                                swiper.update(true);
                                swiper.updateProgress();
                            }, 100);
                        };
                        break;

                    case 'coverflow':
                        settings.effect = 'coverflow';
                        settings.slidesPerView = 'auto';
                        settings.grabCursor = true;
                        settings.centeredSlides = true;
                        settings.coverflow = {
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows : true
                        };
                        // Responsive breakpoints
                        settings.breakpoints = {
                            // when window width is <= 980px
                            980: {
                                effect: 'slide',
                                spaceBetweenSlides: 30
                            }
                        };
                        break;

                    case 'cube':
                        settings.effect = 'cube';
                        settings.grabCursor = true;
                        settings.cube = {
                            shadow: false,
                            slideShadows: false,
                            shadowOffset: 20,
                            shadowScale: 0.94
                        };
                        break;
                    case 'flipcard':
                        settings.effect = 'flip';
                        settings.grabCursor = true;
                        settings.flip = {
                            slideShadows : false,
                            limitRotation: true
                        };
                        break;
                    default:
                        settings.centeredSlides = true;
                        settings.slideToClickedSlide = true;
                        settings.grabCursor = true;
                        //settings.slidesPerView = 1;
                        settings.spaceBetween = 30;
                        settings.autoHeight = true;
                        break;
                }

                settings.onTransitionStart = transitionStart;

                settings.onTransitionEnd = function(swiper) {       // Overwrite default
                    var wrapper = swiper.wrapper[0],
                        active = (wrapper || document).querySelector('.swiper-slide-active'),
                        index = (active && active.dataset) ? active.dataset.swiperSlideIndex : 0,
                        arr = self.loop() ?
                            document.querySelectorAll('[data-swiper-slide-index="' + index + '"]'):
                            Array.prototype.slice.call(
                                (wrapper || document).querySelectorAll('.swiper-slide')
                            ).slice(0, swiper.activeIndex + 1);

                    for (var i = 0; i < arr.length; i++) {
                        arr[i].removeAttribute('data-interacted');
                    }

                    trainingVM.updateVisited();

                    if (self.loop()) {
                        $(settings.nextButton).removeClass('swiper-button-disabled');
                        $(settings.prevButton).removeClass('swiper-button-disabled');
                    } else {
                        switch (swiper.activeIndex) {
                            case 0:
                                $(settings.nextButton).removeClass('swiper-button-disabled');
                                break;
                            case (swiper.slides.length - 1):
                                $(settings.prevButton).removeClass('swiper-button-disabled');
                                break;
                            default:
                                $(settings.nextButton).removeClass('swiper-button-disabled');
                                $(settings.prevButton).removeClass('swiper-button-disabled');
                                break;
                        }
                    }
                };

                require(['swiper', 'hammer'], function(Swiper, Hammer) {
                    var container = document.querySelector('.js-swiper-container.slideshow-comp'),
                        swiper = new Swiper(container, settings);

                    if (!container || !swiper) {
                        return;
                    }

                    var elements = document.getElementsByClassName("js-slide-show-slide");

                    for (var i = 0; i < elements.length; i++) {
                        var manager = new Hammer(elements[i], {
                            recognizers: [
                                [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}],
                            ]
                        });

                        manager.on('swipeleft', function () {
                            swiper.slideTo(swiper.activeIndex + 1);
                            $(settings.nextButton).qtip("hide");
                        });

                        manager.on('swiperight', function () {
                            swiper.slideTo(swiper.activeIndex - 1);
                            $(settings.nextButton).qtip("hide");
                        });
                    }

                    if (!self.ownNavi()) {
                        trainingVM.alternativeNavigation(true);
                        trainingVM.nextAlt = function () {
                            if (swiper.isEnd) {
                                trainingVM.alternativeNavigation(false);
                                trainingVM.next();
                            } else {
                                swiper.slideTo(swiper.activeIndex + 1);
                            }
                        };
                        trainingVM.prevAlt = function () {
                            if (swiper.isBeginning) {
                                trainingVM.alternativeNavigation(false);
                                trainingVM.prev();
                            } else {
                                swiper.slideTo(swiper.activeIndex - 1);
                            }
                        };
                    }

                    var counter = 0,
                        updateSwiper = function () {
                            counter++;
                            swiper.update(true);
                            update3D(swiper);
                            if (counter < 5) {
                                setTimeout(function () {
                                    updateSwiper();
                                }, 200);
                            }
                        };

                    updateSwiper();

                    window.addEventListener('resize', function(){
                        counter = 0;
                        updateSwiper()
                        }, true);

                    if(self.ownNavi() && self.nextTooltip() && showNextInstruction){
                        // Timeout is needed to component get it's size
                        setTimeout(function () {
                            var props = {
                                prerender: true,
                                position: {
                                    viewport: $(window),
                                    container: (layoutVM.isFixed()) ? $('#js-layout-content') : $('body'),
                                    my: 'bottom left',
                                    at: 'top center',
                                    adjust: {
                                        resize: true,
                                        method: 'shift shift',
                                        x: 6,
                                        y: 6
                                    }
                                },
                                style: {
                                    classes: "hs-tooltip qtip-shadow",
                                    tip: {
                                        width: 14,
                                        height: 12,
                                        offset: 10
                                    }
                                },
                                effect: {
                                    type: 'fade'
                                },
                                events: {
                                    hide: preventNextTooltip
                                },
                                show: {},
                                hide: {}
                            };

                            props.show.ready = true;
                            props.show.event = '';

                            props.hide.fixed = true;
                            props.hide.event = 'click';

                            props.position.target = settings.nextButton;

                            props.content = self.nextTooltipText();

                            $(settings.nextButton).qtip(props);
                        }, 1600);
                    }
                    container.classList.remove('vh');
                });

            }
        };

    }
});

